module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video",
    style: ({
      backgroundImage: 'url(' + _vm.bgsrc + ')'
    }),
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inside"
  }, [_c('p', [_vm._v(" aaaaaaaaa ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ec930dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoBox.vue
// module id = 282
// module chunks = 0